<template>
  <v-dialog v-model="dialog" persistent max-width="500">
    <v-card class="pa-6" style="border-radius: 12px;">
      <v-card-title class="font-weight-bold pa-0 mb-4" style="font-size: 20px; color: #333; display: flex; justify-content: space-between; align-items: center;">
        Iniciar sesión
        <v-btn icon small @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pa-0">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            v-model="usuario.email"
            label="Correo electrónico"
            :rules="emailRules"
            required
            outlined
          ></v-text-field>

          <v-text-field
            v-model="usuario.password"
            :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="[rules.required, rules.min]"
            :type="showPass ? 'text' : 'password'"
            label="Contraseña"
            hint="Mínimo 5 caracteres"
            counter
            outlined
            @click:append="showPass = !showPass"
          ></v-text-field>
        </v-form>

        <v-btn
          block
          depressed
          color="#1a73e8"
          class="white--text mt-2"
          style="text-transform: none; border-radius: 8px;"
          @click="ingresar"
        >
          <v-icon left small>mdi-login</v-icon>
          Iniciar sesión
        </v-btn>

        <v-btn
          block
          outlined
          class="mt-2"
          style="text-transform: none; border-radius: 8px; border-color: #ccc;"
          @click="loginWithGoogle"
        >
          <img src="@/assets/img/svg/google-icon.svg" alt="Google" width="18" height="18" class="mr-2">
          Ingresar con Google
        </v-btn>

        <div class="text-center mt-3" style="font-size: 13px;">
          <span style="color: #666;">¿No tenés cuenta?</span>
          <a href="#" class="font-weight-bold" style="color: #1a73e8; text-decoration: none;" @click.prevent="$emit('cambiar-a-registro')">
            Registrarse
          </a>
        </div>

        <v-btn
          block
          outlined
          class="mt-4"
          color="red"
          style="text-transform: none; border-radius: 8px;"
          @click="dialog = false"
        >
          <v-icon left small>mdi-close</v-icon>
          Cerrar Ventana
        </v-btn>
      </v-card-text>
    </v-card>

    <v-snackbar v-model="snackbar.show" :timeout="4000" :color="snackbar.color" text top right>
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn :color="snackbar.colorBtn" text v-bind="attrs" @click="snackbar.show = false">Cerrar</v-btn>
      </template>
    </v-snackbar>
  </v-dialog>
</template>

<script>
import loginService from "@/services/loginService.js";
import router from "@/router/index";

export default {
  props: {
    value: Boolean
  },
  data: () => ({
    valid: true,
    showPass: false,
    usuario: {
      name: "",
      email: "",
      password: ""
    },
    rules: {
      required: (value) => !!value || "Campo Requerido",
      min: (v) => v.length >= 5 || "Mínimo 5 caracteres"
    },
    emailRules: [
      (v) => !!v || "Correo es requerido",
      (v) => /.+@.+\..+/.test(v) || "Correo debe ser válido"
    ],
    snackbar: {
      show: false,
      text: "",
      color: "",
      colorBtn: ""
    }
  }),
  computed: {
    dialog: {
      get() { return this.value; },
      set(v) { this.$emit('input', v); }
    }
  },
  methods: {
    async recaptcha() {
      try {
        await this.$recaptchaLoaded();
        return await this.$recaptcha('login');
      } catch (error) {
        console.error('Error en reCAPTCHA:', error);
        throw error;
      }
    },
    loginWithGoogle() {
      const url = this.$router.resolve({ path: '/api/login/google' }).href;
      window.location.href = url;
    },
    async ingresar() {
      if (!this.$refs.form.validate()) return;

      try {
        const token = await this.recaptcha();
        this.usuario.recaptcha = token;
      } catch (error) {
        return;
      }

      loginService.autenticar(this.usuario).then((response) => {
        const data = response.data.data;
        localStorage.setItem("token", data.token);
        localStorage.setItem("identificador", data.identificador);
        this.dialog = false;
        router.push("/perfil/" + data.identificador + "/add");
        this.limpiar();
      }).catch((e) => {
        const msg = e.response?.data?.message || "Error al iniciar sesión";
        this.snackbar = { show: true, text: msg, color: "error", colorBtn: "error" };
      });
    },
    limpiar() {
      this.usuario = { name: "", email: "", password: "" };
      this.$refs.form?.resetValidation();
    }
  }
};
</script>
